
    import { Component, Vue } from 'vue-property-decorator';
    import { mdiFileSign } from '@mdi/js';

    @Component
    export default class Header extends Vue {
        private title = document.title;
        private signLogo = mdiFileSign;
    }
